import React, { createContext, useContext } from 'react';
import { View, type ViewStyle, type StyleProp } from 'react-native';
import { type SharedValue } from 'react-native-reanimated';
import { useSkeletonPulse } from './useSkeletonPulse';
import { useSkeletonBoneColor } from './skeletonColors';

interface SkeletonContextValue {
  opacity: SharedValue<number>;
  boneColor: string;
}

const SkeletonContext = createContext<SkeletonContextValue | null>(null);

export function useSkeletonContext(): SkeletonContextValue | null {
  return useContext(SkeletonContext);
}

interface SkeletonGroupProps {
  children: React.ReactNode;
  duration?: number;
  colorOverride?: string;
  style?: StyleProp<ViewStyle>;
}

export const SkeletonGroup: React.FC<SkeletonGroupProps> = ({
  children,
  duration,
  colorOverride,
  style,
}) => {
  const opacity = useSkeletonPulse(duration);
  const defaultBoneColor = useSkeletonBoneColor();
  const value: SkeletonContextValue = {
    opacity,
    boneColor: colorOverride ?? defaultBoneColor,
  };

  return (
    <SkeletonContext.Provider value={value}>
      <View style={style}>{children}</View>
    </SkeletonContext.Provider>
  );
};
